import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';

const GradesSection: FC = () => {
	const { width } = useResizeObserver()
	const { transData, list } = useTranslation('oneOnOne.grades')

	const itemList = list.map((item, index) => {
		return (
			<div className={classnames(styles['ac-grades-item'], styles[`ac-grades-item-${item.id}`])} key={index}>
				<div className={styles['ac-grades-avatar']}>
					<img loading='lazy' src={item.img} alt="" />
					<span className={styles['ac-grades-name']}>{item.name}</span>
					<span className={styles['item-date']}>{item.dateText}</span>
				</div>
				<div className={styles['ac-grades-icon']}>
					{Array.from({ length: 5 }).map((_, i) => {
						return (
							<img loading='lazy' src={item.icon} alt="" key={i} />
						)
					})}
				</div>
				<div className={styles['ac-grades-item-context']}>
					<p>{item.content}</p>
				</div>
			</div>)
	})
	const padBetween = (width >= 768 && width < 1192) ? 24 : 32
	const phoneBetween = (width < 768) ? 16 : padBetween
	const spaceBetween = (width >= 768 && width < 1192) ? 0 : phoneBetween
	const phoneSlideConfig = (width < 768) ? 1 : 'auto'
	const sliderConfig = width >= 1192 ? 3 : 'auto'
	return (
		<section className={styles['ac-grades']}>
			<div className={styles['ac-grades-container']}>
				{width >= 1192 && <>
					<img className={styles['ac-grades-img-1']} loading='lazy' src="https://web-data.zmlearn.com/image/oEMUV9MEHeKiG7E1qyvZHz/img_P6_left%402x.png" alt="" />
					<img className={styles['ac-grades-img-2']} loading='lazy' src="https://web-data.zmlearn.com/image/rYESNXJTvfFD8YUiWz277w/img_P6_right%402x.png" alt="" />
				</>}
				{(width >= 768 && width < 1192) && <>
					<img className={styles['ac-grades-img-1']} loading='lazy' src="https://web-data.zmlearn.com/image/erX7cn8J9MB6FxSvYgNjd8/img_P6_left%402x.png" alt="" />
					<img className={styles['ac-grades-img-2']} loading='lazy' src="https://web-data.zmlearn.com/image/6ewSQ7FEjvCKeiWfZvA4nc/img_P6_right%402x.png" alt="" />
					<img className={styles['ac-grades-img-3']} loading='lazy' src="https://web-data.zmlearn.com/image/rf8kiHYzKS6yNMMffTkPFF/img_P6_left%402x%20(1).png" alt="" />
					<img className={styles['ac-grades-img-4']} loading='lazy' src="https://web-data.zmlearn.com/image/fv2oZJAnwFLYXFDWCw3Gj/img_P6_right%402x%20(1).png" alt="" />
				</>}
				<div className={styles['ac-grades-text']}>
					<div dangerouslySetInnerHTML={{ __html: transData.title }} />

					<div className={styles['grades-text-bot']}>
						<div className={styles['ac-grades-start']}>
							{Array.from({ length: 5 }).map((_, i) => {
								return (
									<img loading='lazy' src="https://web-data.zmlearn.com/image/89Ni5QKBmsw52uXQnqYYEN/icon_star_face%402x.png" alt="" key={i} />
								)
							})}
						</div>
						<div className={styles['ac-grades-number']}>
							<div className={styles['ac-grades-number-1']}>4.9/5</div>
							<div className={styles['ac-grades-number-2']}>{transData.commentText}</div>
						</div>
					</div>
				</div>
				<AcSwipe className={classnames(styles['ac-grades-banner'], 'ac-grades-banner')}
					loop={true}
					spaceBetween={spaceBetween}
					pagination={{
						clickable: true,
					}}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					centeredSlides={true}
					slidesPerView={sliderConfig}
				>{itemList}</AcSwipe>

			</div>
		</section>
	);
}

export default GradesSection
